import { commonAttrs as commonAttrsFn } from '../utils';
export const useCFTestID = (defaultTestID, props) => {
    const defaultProps = { testID: defaultTestID };
    const { testID = defaultTestID } = props || defaultProps;
    const commonAttrs = commonAttrsFn(Object.assign(Object.assign({}, defaultProps), props));
    const elementTestIDString = (suffix) => `${testID}-${suffix}`;
    const elementTestID = (suffix) => {
        return {
            'data-testid': elementTestIDString(suffix),
        };
    };
    return {
        commonAttrs,
        elementTestID,
        elementTestIDString,
        testID,
    };
};
